// PartBPage1/index.jsx - Part B Page 1 (Student Editor)
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useActivityContext } from '../index';
import { API_CONFIG } from '../../../../../config/api';

const PartBPage1 = () => {
    const { activity, userRole } = useActivityContext();
    const [teacherFields, setTeacherFields] = useState({
        subjects: [],
        curricular_goals: [],
        competencies: [],
        pedagogies: {},
        project_prompt: ''
    });
    const [studentFields, setStudentFields] = useState({
        guiding_questions: [],
        what_i_know: '',
        what_i_need_to_find_out: ''
    });
    const [saveStatus, setSaveStatus] = useState('');

    useEffect(() => {
        if (activity?.part_b?.page_1?.teacher_fields) {
            setTeacherFields(activity.part_b.page_1.teacher_fields);
        }
        if (activity?.my_response?.page_1) {
            setStudentFields(activity.my_response.page_1);
        }
    }, [activity]);

    const pedagogyOptions = [
        { key: 'art_integrated', label: 'Art-integrated' },
        { key: 'sports_integrated', label: 'Sports-integrated' },
        { key: 'toy_based', label: 'Toy-based' },
        { key: 'technology_integrated', label: 'Technology-integrated' },
        { key: 'skill_based_learning', label: 'Skill-based learning' },
        { key: 'drama_theatre_integrated', label: 'Drama/Theatre-integrated' },
        { key: 'indian_knowledge_systems', label: 'Indian Knowledge Systems approaches' }
    ];

    const saveData = async (field, value, owner) => {
        try {
            setSaveStatus('Saving...');
            const token = localStorage.getItem('accessToken');
            const apiUrl = API_CONFIG.BASE_URL;
            const endpoint = owner === 'teacher'
                ? `${apiUrl}/secondary/teacher/domain-activities/${activity.activity_id}/part-b/page/1/teacher-fields`
                : `${apiUrl}/secondary/user/domain-activities/${activity.activity_id}/part-b/page/1/student-fields`;

            await axios.put(endpoint, owner === 'teacher' ? { [field]: value } : { ...studentFields, [field]: value }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setSaveStatus('✓ Saved');
            setTimeout(() => setSaveStatus(''), 2000);
        } catch (error) {
            console.error('Save error:', error);
            setSaveStatus('Error');
        }
    };

    const handleStudentArrayChange = (field, text) => {
        const arr = text.split('\n').filter(x => x.trim());
        setStudentFields(prev => ({ ...prev, [field]: arr }));
    };

    const handleStudentTextChange = (field, value) => {
        setStudentFields(prev => ({ ...prev, [field]: value }));
    };

    const handleStudentBlur = (field) => {
        saveData(field, studentFields[field], 'student');
    };

    const renderList = (items) => {
        if (!items || items.length === 0) return <div style={{ fontSize: '15px', color: '#999' }}>-</div>;
        return (
            <div style={{ fontSize: '15px', lineHeight: '1.6' }}>  {/* Increased from 13px */}
                {items.map((item, idx) => (
                    <div key={idx} style={{ marginBottom: '3px' }}>• {item}</div>
                ))}
            </div>
        );
    };

    const renderText = (text) => {
        if (!text || text.trim() === '') return <div style={{ fontSize: '15px', color: '#999' }}>-</div>;
        return <div style={{ fontSize: '15px', lineHeight: '1.5', whiteSpace: 'pre-wrap' }}>{text}</div>; {/* Increased from 13px */ }
    };

    return (
        <div style={{
            width: '100%',           // fluid width
            maxWidth: '1400px',      // increased from 1200px
            minHeight: '80vh',       // dynamic height
            margin: '0 auto',        // center without wrapper
            padding: '40px',         // readable padding
            backgroundColor: 'white',
            position: 'relative',
            fontFamily: "'Poppins', Arial, sans-serif",  // Updated to Poppins
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)', // optional: nicer shadow
            borderRadius: '8px',     // optional: nicer corners
            boxSizing: 'border-box'  // CRITICAL: prevents padding from breaking width
        }}>
            {/* Save Status */}
            {saveStatus && (
                <div style={{
                    position: 'fixed',
                    top: '20px',
                    right: '20px',
                    backgroundColor: saveStatus.includes('Error') ? '#f44336' : '#4caf50',
                    color: 'white',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    zIndex: 1000
                }}>
                    {saveStatus}
                </div>
            )}

            {/* Header */}
            <div style={{
                fontSize: '24px',      // Increased from 20px
                fontWeight: 'bold',
                marginBottom: '10px',
                textAlign: 'center',
                color: '#F4824C'
            }}>
                PART B
            </div>

            <div style={{
                backgroundColor: '#F4824C',
                color: 'white',
                fontSize: '16px',      // Increased from 14px
                fontWeight: 'bold',
                padding: '10px',
                textAlign: 'center',
                marginBottom: '20px'
            }}>
                Group Project Work
            </div>

            {/* TEACHER FIELDS - VIEW ONLY FOR STUDENTS */}
            <div style={{ marginBottom: '16px' }}>
                <div style={{
                    backgroundColor: '#F4824C',
                    color: 'white',
                    padding: '8px 14px',
                    fontWeight: 'bold',
                    fontSize: '14px',
                    borderRadius: '20px',
                    display: 'inline-block',
                    marginBottom: '8px'
                }}>
                    Subject(s)<br />(Can be more than one)
                </div>
                <div style={{
                    backgroundColor: '#FFE5D5',
                    padding: '12px',
                    minHeight: '40px',
                    borderRadius: '4px'
                }}>
                    {renderList(teacherFields.subjects)}
                </div>
            </div>

            <div style={{ marginBottom: '16px' }}>
                <div style={{
                    backgroundColor: '#F4824C',
                    color: 'white',
                    padding: '8px 14px',
                    fontWeight: 'bold',
                    fontSize: '14px',
                    borderRadius: '20px',
                    display: 'inline-block',
                    marginBottom: '8px'
                }}>
                    Curricular goal(s)<br />(Can be more than one)
                </div>
                <div style={{
                    backgroundColor: '#FFE5D5',
                    padding: '12px',
                    minHeight: '40px',
                    borderRadius: '4px'
                }}>
                    {renderList(teacherFields.curricular_goals)}
                </div>
            </div>

            <div style={{ marginBottom: '16px' }}>
                <div style={{
                    backgroundColor: '#F4824C',
                    color: 'white',
                    padding: '8px 14px',
                    fontWeight: 'bold',
                    fontSize: '14px',
                    borderRadius: '20px',
                    display: 'inline-block',
                    marginBottom: '8px'
                }}>
                    Competency(-ies)<br />(Can be more than one)
                </div>
                <div style={{
                    backgroundColor: '#FFE5D5',
                    padding: '12px',
                    minHeight: '40px',
                    borderRadius: '4px'
                }}>
                    {renderList(teacherFields.competencies)}
                </div>
            </div>

            {/* Pedagogies */}
            <div style={{ marginBottom: '16px' }}>
                <div style={{ display: 'flex', gap: '12px' }}>
                    <div style={{
                        backgroundColor: '#F4824C',
                        color: 'white',
                        padding: '12px 16px',
                        fontWeight: 'bold',
                        fontSize: '14px',      // Increased from 11px
                        flex: '0 0 auto',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                        minWidth: '140px'
                    }}>
                        Pedagogies<br />(Tick (✓) all that apply.)
                    </div>
                    <div style={{
                        backgroundColor: '#FFE5D5',
                        padding: '12px 16px',
                        flex: 1,
                        display: 'grid',
                        // gridTemplateColumns: 'repeat(2, 1fr)',
                        // This automatically fits as many columns as possible based on width
                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                        gap: '8px',
                        fontSize: '15px'      // Increased from 13px
                    }}>
                        {pedagogyOptions.map(opt => (
                            <div key={opt.key} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <div style={{
                                    width: '16px',
                                    height: '16px',
                                    border: '2px solid #333',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '12px',
                                    flexShrink: 0
                                }}>
                                    {teacherFields.pedagogies?.[opt.key] && '✓'}
                                </div>
                                <span>{opt.label}</span>
                            </div>
                        ))}
                        <div style={{
                            gridColumn: '1 / -1',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            marginTop: '4px'
                        }}>
                            <div style={{ width: '16px', height: '16px', border: '2px solid #333', flexShrink: 0 }}>
                                {teacherFields.pedagogies?.any_other && '✓'}
                            </div>
                            <span>Any other{teacherFields.pedagogies?.any_other && `: ${teacherFields.pedagogies.any_other}`}</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Project Prompt */}
            <div style={{ marginBottom: '16px' }}>
                <div style={{
                    backgroundColor: '#F4824C',
                    color: 'white',
                    padding: '10px 14px',
                    fontWeight: 'bold',
                    fontSize: '14px',      // Increased from 11px
                    marginBottom: '8px',
                    borderTopLeftRadius: '15px',
                    borderTopRightRadius: '15px'
                }}>
                    Project prompt/question/problem/challenge/<br />planned final output
                </div>
                <div style={{
                    backgroundColor: '#FFE5D5',
                    padding: '12px',
                    minHeight: '60px',
                    lineHeight: '1.5'
                }}>
                    {renderText(teacherFields.project_prompt)}
                </div>
            </div>

            {/* STUDENT FIELDS - EDITABLE */}
            <div style={{ marginBottom: '16px' }}>
                <div style={{
                    backgroundColor: '#4A90A4',
                    color: 'white',
                    padding: '10px 14px',
                    fontWeight: 'bold',
                    fontSize: '14px',      // Increased from 11px
                    marginBottom: '8px',
                    borderTopLeftRadius: '15px',
                    borderTopRightRadius: '15px'
                }}>
                    Guiding questions
                </div>
                <textarea
                    value={(studentFields.guiding_questions || []).join('\n')}
                    onChange={(e) => handleStudentArrayChange('guiding_questions', e.target.value)}
                    onBlur={() => handleStudentBlur('guiding_questions')}
                    placeholder="Enter each question on a new line..."
                    style={{
                        width: '100%',
                        backgroundColor: '#C5E3ED',
                        padding: '12px',
                        minHeight: '80px',
                        border: '1px solid #4A90A4',
                        borderRadius: '4px',
                        fontSize: '15px',      // Increased from 13px
                        fontFamily: 'inherit',
                        resize: 'vertical'
                    }}
                />
            </div>

            {/* Two Column Layout */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '20px' }}>
                <div>
                    <div style={{
                        backgroundColor: '#4A90A4',
                        color: 'white',
                        padding: '10px 14px',
                        fontWeight: 'bold',
                        fontSize: '11px',
                        textAlign: 'center',
                        marginBottom: '8px'
                    }}>
                        What do I know?
                    </div>
                    <textarea
                        value={studentFields.what_i_know || ''}
                        onChange={(e) => handleStudentTextChange('what_i_know', e.target.value)}
                        onBlur={() => handleStudentBlur('what_i_know')}
                        placeholder="What I already know..."
                        style={{
                            width: '100%',
                            backgroundColor: '#C5E3ED',
                            padding: '12px',
                            minHeight: '120px',
                            border: '1px solid #4A90A4',
                            borderRadius: '4px',
                            fontSize: '13px',
                            fontFamily: 'inherit',
                            lineHeight: '1.5',
                            resize: 'vertical'
                        }}
                    />
                </div>

                <div>
                    <div style={{
                        backgroundColor: '#4A90A4',
                        color: 'white',
                        padding: '10px 14px',
                        fontWeight: 'bold',
                        fontSize: '11px',
                        textAlign: 'center',
                        marginBottom: '8px'
                    }}>
                        What do I need to find out?
                    </div>
                    <textarea
                        value={studentFields.what_i_need_to_find_out || ''}
                        onChange={(e) => handleStudentTextChange('what_i_need_to_find_out', e.target.value)}
                        onBlur={() => handleStudentBlur('what_i_need_to_find_out')}
                        placeholder="What I need to research..."
                        style={{
                            width: '100%',
                            backgroundColor: '#C5E3ED',
                            padding: '12px',
                            minHeight: '120px',
                            border: '1px solid #4A90A4',
                            borderRadius: '4px',
                            fontSize: '13px',
                            fontFamily: 'inherit',
                            lineHeight: '1.5',
                            resize: 'vertical'
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default PartBPage1;
